<template>
  <div class="wrapper">
    <AlertErrorMsg
      ref="alert"
      :title="errorMessage"
    />
    <div class="content-wrapper">
      <HeaderRegistered :title="caseTitle" />
      <main class="main">
        <section class="case-activity-section">
          <div
            v-if="subscriptionsInfo"
            class="payment-alert-wrapper"
          >
            <div class="payment-alert">
              <div class="alert-msg">
                <WhiteWarningIcon36 />
                <p v-text="`Payment for case ${caseTitle} did not complete. To try again, click “Synchronize”.`" />
              </div>
              <div class="payment-alert-update">
                <button
                  class="payment-alert-update-btn"
                  @click="updateSubscriptionsInfo"
                >
                  Synchronize
                </button>
                <span class="payment-alert-update-last-sync">Last sync {{ synchronizedAt }}</span>
              </div>
            </div>
          </div>
          <div class="container-full">
            <div class="case-activity">
              <div class="case-activity-header">
                <h3 class="case-activity-title">
                  Case activity
                </h3>
                <div class="case-actions">
                  <button
                    v-if="hasPermission(['configuration_case'])"
                    id="case_detail_dropdown_settings"
                    class="btn"
                    style="max-width: 143px"
                    @click="$router.push({path: `/cases/${caseId}/settings`}).catch(()=>{})"
                  >
                    Case settings
                    <GreySettingsIcon24 />
                  </button>
                  <button
                    v-if="hasPermission(['export_case'])"
                    id="case_detail_dropdown_export"
                    class="btn"
                    @click="$router.push({path: `/cases/${caseId}/export`}).catch(() => {})"
                  >
                    Download all data
                    <GreyDownloadIcon24 />
                  </button>
                  <CaseDropdown
                    v-if="!$route.path.includes('case-actions')"
                    :tooltip-placement="'bottom'"
                    :case-name="caseTitle"
                    :has-left-offset="true"
                  >
                    More...
                    <Grey3DotMenuIcon24 />
                  </CaseDropdown>
                </div>
              </div>
              <div class="case-activity-info">
                <div
                  v-if="this.dataActivity && this.dataActivity.messagesStatistic && this.dataActivity.messagesStatistic.messages.length"
                  class="holder-chart"
                >
                  <span class="chart-title">Messages</span>
                  <ColumnChart
                    id="rad"
                    :data-activity="dataActivity.messagesStatistic"
                    :max="maxValueStatistic"
                  />
                </div>
                <transition name="tray">
                  <CaseDataInfo v-if="isLoaded" :data-activity="dataActivity" />
                </transition>
              </div>
              <CaseManagmentBar :case-manager="casesManager" />
              <div class="case-users-details">
                <CaseMembersBar />
              </div>
            </div>
          </div>
        </section>
        <DeactivateItemPopUp
          ref="deactivateItemPopUp"
        />
      </main>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import hasPermission from '@/utils/permission';
import CaseDataInfo from '../case-data/CaseDataInfo';
import CaseManagmentBar from '../case-bars/CaseManagmentBar';
import DeactivateItemPopUp from '../../popups/DeactivateItemPopUp';
import CaseMembersBar from '../case-bars/CaseMembersBar';
import ColumnChart from '../../Charts/ColumnChart';
import AlertErrorMsg from '../../profile/AlertErrorMsg';
import errorHandler from '@/mixins/errorHandler';
import WhiteWarningIcon36 from '@/components/icons/WhiteWarningIcon36.vue';
import CaseDropdown from '@/components/cases/case-buttons/CaseDropdown.vue';
import GreySettingsIcon24 from '@/components/icons/GreySettingsIcon24.vue';
import GreyDownloadIcon24 from '@/components/icons/GreyDownloadIcon24.vue';
import Grey3DotMenuIcon24 from '@/components/icons/Grey3DotMenuIcon24.vue';
import HeaderRegistered from '@/components/layout/HeaderRegistered.vue';

export default {
  name: 'CaseDetails',
  components: {
    HeaderRegistered,
    Grey3DotMenuIcon24,
    GreyDownloadIcon24,
    GreySettingsIcon24,
    CaseDropdown,
    WhiteWarningIcon36,
    AlertErrorMsg,
    ColumnChart,
    CaseDataInfo,
    CaseManagmentBar,
    DeactivateItemPopUp,
    CaseMembersBar,
  },
  mixins: [errorHandler],
  props: {
    name: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      isLoaded: false,
      caseNumber: this.$route.name,
      caseId: this.$route.params.slug,
      casesManager: {},
      dataActivity: null,
      subscriptionsInfo: null,
      maxValueStatistic: null,
      caseTitle: '',
      synchronizedAt: '',
      errorMessage: '',
      users: [],
    };
  },
  computed: {
    casePage() {
      return localStorage.getItem('casePage');
    }
  },
  watch: {
    errorMessage(val) {
      if (val) {
        this.$refs.alert.showAlert();
      }
    },
    error(val) {
      if (val) {
        this.$refs.alert.showAlert();
      }
    }
  },
  created() {
    this.getCaseStatistic();
  },
  mounted() {
    this.getManager();
    this.getSubscriptionsInfo();
    this.caseTitle = localStorage.getItem('title');
  },
  methods: {
    hasPermission,
    getUsers() {
      this.$load(async () => {
        await this.$api.cases.getCasesUsers({
          caseId: this.caseId,
          keySearch: '',
          roles: '',
          sortBy: '',
          order: 'desc'
        }).then((res) => {
            this.users = res.data.body;
            this.isLoaded = true;
          }, (error => {
            this.handleResponseError(error);
          })
        );
      });
    },
    getManager() {
      this.$load(async () => {
        await this.$api.cases.getCasesManager({caseId: this.caseId}).then((res) => {
            this.casesManager = res.data.body;
          }, (error => {
            this.handleResponseError(error);
          })
        );
      });
    },
    getCaseStatistic() {
      this.$load(() => {
        this.$api.cases.getCaseStatistic(this.caseId).then(res => {
          this.dataActivity = res.data.body;
          if (this.dataActivity.messagesStatistic.messages.length) {
            const maxItemfromArray = this.dataActivity.messagesStatistic.messages.reduce((prev, current) => prev.messagesAmount > current.messagesAmount ? prev : current, {});
            this.maxValueStatistic = maxItemfromArray.messagesAmount;
          }
          this.isLoaded = true;
        }).catch((error => {
          this.handleResponseError(error);
        }));
      });
    },
    getSubscriptionsInfo() {
      this.$load(() => {
        this.$api.cases.getSubscriptionsInfo(this.caseId).then(res => {
          if (res.data.body.subscriptionsInfo.length) {
            this.subscriptionsInfo = true;
            this.synchronizedAt = moment(res.data.body.subscriptionsInfo[0].synchronizedAt * 1000).format('HH:mm DD/MM/yy');
          }
        }).catch((error => {
          this.handleResponseError(error);
        }));
      });
    },
    updateSubscriptionsInfo() {
      this.$load(() => {
        this.$api.cases.updateSubscriptionsInfo(this.caseId).then(() => {
        }).catch((error => {
          this.handleResponseError(error);
        }));
      });
    }
  }
};
</script>

<style scoped>
.case-activity-section {
  display: flex;
  flex-wrap: wrap;
  background-color: var(--white-color);
  padding: 24px 24px 24px 35px;
}

.case-activity-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.case-activity-title {
  margin: 0;
  font-size: 14px;
  line-height: 14px;
  font-weight: 700;
  color: var(--light-gray);
  text-transform: uppercase;
}

.case-activity-link {
  text-decoration: underline;
  font-size: 14px;
  line-height: 14px;
  color: var(--secondary-text-color);
  font-weight: 500;
}

.case-activity-info {
  margin: 30px 0 0 0;
  padding: 0 0 40px 0;
  border-bottom: 1px solid var(--input-placeholder-value-color);
  display: flex;
  min-height: 260px;
}

.case-activity-graph {
  width: 437px;
  height: 214px;
}

.case-activity-info img {
  max-width: 100%;
  max-height: 100%;
}

.holder-chart {
  position: relative;
  width: 400px;
  display: flex;
  align-items: flex-end;
  /*margin: 0px auto;*/
  /*overflow: hidden;*/
}

.chart-title {
  position: absolute;
  z-index: 2;
  top: 15%;
  left: 0;
  font-size: 8px;
  font-weight: 500;
  line-height: 13px;
  color: var(--light-gray);
}

.holder-chart {
  margin-right: 56px;
}

.payment-alert-wrapper {
  width: 100%;
  margin-bottom: 15px;
}

.payment-alert {
  background: #F1105F;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
}

.alert-msg {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.payment-alert .alert-msg p {
  margin-bottom: 0;
  margin-left: 10px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #FFFFFF;
}

.payment-alert-update-btn {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  background: transparent;
  border: 1px solid #fff;
  padding: 8px 40px;
  border-radius: 25px;
  transition: all .5s;
}

.payment-alert-update-btn:hover {
  background: #fff;
  color: #F1105F;
}

.payment-alert-update-last-sync {
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  align-items: center;
  text-align: right;
  color: #F8FCFC;
  display: block;
  margin-top: 15px;
}

.case-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
  max-width: 430px;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 500;
  font-size: 12px;
  line-height: 120%;
  vertical-align: middle;
  max-width: 167px;
  width: 100%;
  color: var(--secondary-text-color);
  border: 1px solid var(--secondary-text-color);
  background-color: var(--white-color);
  height: 35px;
}

.btn >>> svg path {
  fill: var(--secondary-text-color);
}

</style>
